<template lang="html">

  <section class="recuperar-pass">
    <encabezado :data="'restablecer_login'"></encabezado>

    <div class="container column-center">

      <div class="text-container">

        <p><strong>{{$t('sigue_pasos')}}</strong></p>

      </div>

      <form class="row-between" @submit.prevent="validate">

        <div class="contenedor-input one-slot">
          <label for="">{{$t('nueva_contrasena')}}*</label>
          <input type="password" name="password" v-validate="'required|min:6'" autocomplete='password' :class="[{'has-error' : errors.has('password')}]" :style="style.input_black" ref="password" v-model="password">
          <span class='error' v-if="clicked">{{ errors.first('password')}}</span>
        </div>

        <div class="contenedor-input one-slot -wo-margin">
          <label for="">{{$t('repetir_contrasena')}}*</label>
          <input type="password" name="password2" v-validate="'required|min:6|confirmed:password'" autocomplete='password' :class="[{'has-error' : errors.has('password2')}]" data-vv-as="password" :style="style.input_black" v-model="password2">
          <span class='error' v-if="clicked">{{ errors.first('password2')}}</span>
        </div>

        <div class="contenedor-input one-slot">

          <button class="btn" :style="style.solidPrimary" :loading="loading" >{{$t('guardar')}}</button>

        </div>


      </form>


    </div>

  </section>

</template>

<script lang="js">

  import encabezado from '@/components/parts/encabezado';
  import {mapGetters, mapActions} from 'vuex';
  import Vue from 'vue';
  import VeeValidate from 'vee-validate';
  Vue.use(VeeValidate);
  import axios from 'axios'
  import VueAxios from 'vue-axios'

  export default  {
    name: 'recuperar-pass',
    data(){
      return {
        password : '',
        password2 : '',
        clicked : false,
        loading : false
      }
    },
    methods : {
      ...mapActions(['sendPassword']),
      validate : function(){
        this.$validator.validateAll().then(itsOk => {
          if(itsOk){
            let data = {
              'parametros' : location.search.replace("?p=", ''),
              'nuevaPassword' : this.password
            };
            this.loading = true;    
            this.sendPassword(data).then(r => console.log(r));
          }else{
            this.clicked = true;
          }
        });
      },
    },
    computed : {
      ...mapGetters({
        style : 'getStyles',
        colors : 'basicColors'
      }),
    },
    components: {
      'encabezado' : encabezado
    }
  }
</script>

<style scoped lang="scss">

  form{
    max-width: 500px;
  }

.text-container{
  margin: 50px auto;
  width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/views/recuperar-pass.vue